const CoraSGRIconMenu = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_4361_28777)"
      fill-opacity="0.1"
    />
    <g clip-path="url(#clip0_4361_28777)">
      <path
        d="M13.7747 9.41519C14.2217 9.74704 14.0791 10.5435 13.5369 10.7615C12.9662 10.9796 11.5489 10.7995 10.8545 10.8469C9.16136 10.9606 7.49676 12.1079 6.71678 13.5964C5.02364 16.858 7.15433 20.7264 10.7594 21.1531C10.9877 21.1815 11.8533 21.2479 12.015 21.191C12.4049 21.0582 11.663 19.3326 12.6903 19.4654L16.1241 21.6745C16.2858 21.8831 16.2668 22.196 16.048 22.3667C15.0398 22.945 14.0791 23.732 13.0803 24.2914C12.8045 24.4431 12.5381 24.6422 12.2623 24.3483C11.9864 24.0543 12.1386 23.7604 12.1386 23.457C12.1386 23.4001 12.1006 23.3338 12.1006 23.2674C12.1006 23.1631 12.2147 22.9071 12.1006 22.8218C12.015 22.7649 11.2445 22.8218 11.0542 22.8028C6.26971 22.4615 3.12124 17.7208 5.10925 13.2362C6.53605 10.0315 9.74159 8.93164 13.0993 9.19712C13.3466 9.21608 13.5844 9.26349 13.7842 9.41519H13.7747Z"
        fill="#052351"
      />
      <path
        d="M19.8712 12.2216C19.8331 12.3828 19.5287 12.563 19.367 12.5345L15.9427 10.3823C15.6859 10.1642 15.7525 9.72806 16.0473 9.57636C17.0366 9.03593 17.9878 8.2395 18.958 7.68958C19.1863 7.56632 19.3385 7.43358 19.6143 7.53788C20.109 7.73699 19.7285 8.76097 19.9187 9.17815C21.4692 9.18763 22.8865 9.41518 24.2277 10.2116C27.6234 12.2311 28.5271 16.7632 26.2252 19.9679C24.5035 22.3572 21.6689 23.0683 18.8248 22.8123C17.7024 22.708 17.6358 21.2668 18.92 21.1625C19.9473 21.0867 20.9175 21.2763 21.9448 21.0393C25.3215 20.2334 26.9291 16.3081 25.1313 13.331C24.066 11.5769 22.0209 10.6952 19.9948 10.8279C19.9568 10.8279 19.8617 10.9227 19.8617 10.9322C19.8617 11.264 19.9187 11.9657 19.8617 12.2406L19.8712 12.2216Z"
        fill="#052351"
      />
      <path
        d="M13.8786 15.5118C12.9179 14.4119 14.516 13.5965 15.4767 13.5112C16.4374 13.4259 18.1781 13.881 17.9212 15.123C17.6454 16.4504 14.7442 16.5073 13.8786 15.5212V15.5118Z"
        fill="#052351"
      />
      <path
        d="M13.7835 17.2942C13.7835 17.2942 13.9262 17.5028 14.0118 17.5692C14.944 18.3277 16.5896 18.3371 17.5313 17.5881C17.6644 17.4838 17.8832 17.0761 17.9308 17.4459C18.0259 18.2518 16.7988 18.7069 16.152 18.7733C15.1723 18.8681 13.5172 18.5363 13.6123 17.2752C13.6694 17.2752 13.7455 17.2563 13.7931 17.2847L13.7835 17.2942Z"
        fill="#052351"
      />
      <path
        d="M13.8216 16.1469C14.7442 16.9908 16.2947 17.2278 17.36 16.4503C17.4647 16.3745 17.8356 15.9289 17.9308 16.0237C18.0164 16.5451 17.6549 16.9434 17.2174 17.1804C16.3042 17.6545 14.8203 17.6165 14.0023 16.9718C13.7835 16.7917 13.4696 16.2891 13.6884 16.0331C13.774 16.0142 13.7835 16.1185 13.8311 16.1564L13.8216 16.1469Z"
        fill="#052351"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4361_28777"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0062FF" />
        <stop offset="1" stop-color="#004BC2" />
      </linearGradient>
      <clipPath id="clip0_4361_28777">
        <rect width="23" height="17" fill="white" transform="translate(4.5 7.5)" />
      </clipPath>
    </defs>
  </svg>
)

export default CoraSGRIconMenu
